import { render } from "./Number.vue?vue&type=template&id=35e28c0f"
import script from "./Number.vue?vue&type=script&lang=ts"
export * from "./Number.vue?vue&type=script&lang=ts"
script.render = render

export default script